import React from 'react';
import { useParams } from 'react-router-dom';
import Layout from '../components/Layout';
import ClientsSearch from './ClientsSearch';

const Clients = () => {
  const { clientId, facilityId } = useParams();
  
  return (
    <Layout>
      <ClientsSearch clientId={clientId} facilityId={facilityId} />
    </Layout>
  );
};

export default Clients;
